import { z } from 'zod'

export const WingDetailFormEntitySchema = z
  .object({
    id: z.string(),
    entityId: z.string().optional(),
    name: z.string(),
    roomCount: z.number(),
    priority: z.number(),
    roomTypes: z.array(
      z
        .object({
          id: z.string(),
          entityId: z.string().optional(),
          name: z.string(),
          priority: z.number(),
          worksRoomCount: z.number(),
          compassRoomCount: z.number(),
          isDeleted: z.boolean().optional(),
        })
        .refine(
          data => {
            if (!data.isDeleted) {
              return data.name.length > 0
            }
            return true
          },
          { message: '必須項目', path: ['name'] }
        )
    ),
    isDeleted: z.boolean().optional(),
  })
  .refine(
    data => {
      if (!data.isDeleted) {
        return data.name.length > 0
      }
      return true
    },
    { message: '必須項目', path: ['name'] }
  )

export const BulkUpdateWingDetailFormEntitySchema = z.object({
  items: z.array(WingDetailFormEntitySchema),
})

export type WriteWingDetailFormEntity = z.infer<typeof WingDetailFormEntitySchema>
export type BulkUpdateWingDetailFormEntity = z.infer<typeof BulkUpdateWingDetailFormEntitySchema>
